export const ApplicationActionBarEN = {
    "applicationActionBar": {
        "tab": {
            "detail":"Detail",
        },
        "item": {
            "delete": "Delete",
            "history": "History",
            "update": "Update",
            "approval": "Approval"
        }
    }
}